import CaptivateCardImg from './ImageOrientation/CaptivateCardImg';
import CaptivatePotraitImg from './ImageOrientation/CaptivatePotraitImg';

import * as S from './CaptivativeImagesGrid.styles';

const CaptivateImageGridTwo = ({dataList, variation = 1, updateCarouselState = imageNo => {}}) => {
  if (dataList.length !== 2) return null;

  const ImgComponent = variation % 2 !== 0 ? CaptivatePotraitImg : CaptivateCardImg;

  return (
    <S.CaptivateImageGridContainer>
      {dataList.map((item, index) => (
        <ImgComponent
          key={`${item?.mediaType}-${item?.roomCode || ''}-${index}-2`}
          imgUrl={item.url}
          updateCarouselState={updateCarouselState}
          imageNo={item.imageNo || 1}
          isVideo={item.mediaType === 'VIDEO'}
          thumbnailUrl={item.thumbnailURL}
        />
      ))}
    </S.CaptivateImageGridContainer>
  );
};

export default CaptivateImageGridTwo;
